import Wishlist from './wishlist/Wishlist'

export default function WishlistPage() {
  return <Wishlist />
}
